<template>
  <div class="plan-definition-container app-page app-page--fill">
    <div class="main-content">
      <div class="left-panel">
        <el-card shadow="hover" class="list-card">
          <template #header>
            <PageHeader size="card">
              <template #title>体检方案列表</template>
              <template #actions>
                <el-button type="primary" :icon="Plus" @click="addNewPlan">新增</el-button>
                <el-button
                  type="primary"
                  circle
                  size="small"
                  class="app-refresh-btn"
                  :icon="Refresh"
                  :loading="listLoading"
                  title="刷新"
                  @click="loadPlanList"
                />
              </template>
            </PageHeader>
          </template>

          <div class="plan-list-wrapper">
            <DynamicTable
              :data="planList"
              :model="planTableModel"
              :column-labels="planTableLabels"
              :column-order="planTableColumnOrder"
              :hidden-columns="planHiddenColumns"
              :loading="listLoading"
              :show-column-selector="false"
              :show-export="false"
              :show-edit-button="true"
              :show-delete-button="true"
              :pagination="planPagination"
              :active-row-key="activePlanRowKey"
              @edit="handlePlanEdit"
              @delete="handlePlanDelete"
              @filter="handleFilter"
              @page-change="handlePlanPageChange"
              @page-size-change="handlePlanPageSizeChange"
            />
          </div>
        </el-card>
      </div>

      <div class="right-panel">
        <el-card shadow="hover" class="plan-form-card">
          <template #header>
            <PageHeader size="card">
              <template #title>体检方案详情</template>
            </PageHeader>
          </template>

          <div class="plan-detail-container" v-loading="detailLoading" element-loading-text="加载中...">
            <div v-if="currentPlan" class="edit-area">
              <div class="edit-mode-control">
                <div class="left-actions">
                  <el-button v-if="!isEditMode" type="primary" :icon="Edit" @click="enterEditMode">
                    编辑
                  </el-button>
                  <el-button v-else :icon="Close" @click="exitEditMode">
                    取消编辑
                  </el-button>
                </div>
                <div v-if="isEditMode" class="right-actions">
                  <el-button type="primary" :icon="DocumentChecked" :loading="saveLoading" @click="savePlanData">
                    保存数据
                  </el-button>
                  <el-button :icon="RefreshLeft" :disabled="saveLoading" @click="resetCurrentPlan">
                    重置
                  </el-button>
                </div>
              </div>

              <el-form
                ref="planFormRef"
                :model="currentPlan"
                :rules="planFormRules"
                label-width="150px"
                class="form-content"
              >
                <el-row :gutter="24">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="项目名称" prop="projectName">
                      <el-input
                        v-model="currentPlan.projectName"
                        placeholder="请输入项目名称"
                        :readonly="!isEditMode"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="项目编码" prop="projectCode">
                      <el-input
                        v-model="currentPlan.projectCode"
                        placeholder="请输入项目编码"
                        :readonly="!isEditMode"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="24">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="委托人" prop="clientName">
                      <el-input
                        v-model="currentPlan.clientName"
                        placeholder="请输入委托人"
                        :readonly="!isEditMode"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="委托人联系电话" prop="clientPhone">
                      <el-input
                        v-model="currentPlan.clientPhone"
                        placeholder="请输入委托人联系电话"
                        :readonly="!isEditMode"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="24">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="所有权人" prop="ownerName">
                      <el-input
                        v-model="currentPlan.ownerName"
                        placeholder="请输入所有权人"
                        :readonly="!isEditMode"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="所有权人联系电话" prop="ownerPhone">
                      <el-input
                        v-model="currentPlan.ownerPhone"
                        placeholder="请输入所有权人联系电话"
                        :readonly="!isEditMode"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="24">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="使用人" prop="userName">
                      <el-input
                        v-model="currentPlan.userName"
                        placeholder="请输入使用人"
                        :readonly="!isEditMode"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :xs="24" :sm="24" :md="12" :lg="12">
                    <el-form-item label="管理人" prop="managerName">
                      <el-input
                        v-model="currentPlan.managerName"
                        placeholder="请输入管理人"
                        :readonly="!isEditMode"
                      />
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="24">
                  <el-col :xs="24" :sm="24" :md="24" :lg="24">
                    <el-form-item label="默认体检方案" prop="defaultPlanId">
                      <div class="default-plan-control">
                        <el-button
                          type="primary"
                          plain
                          class="choose-plan-btn"
                          :disabled="!isEditMode"
                          @click="openDefaultPlanDialog"
                        >
                          选择默认体检方案
                        </el-button>
                        <el-tag
                          v-if="currentPlan.defaultPlanId"
                          type="success"
                          effect="light"
                          class="selected-plan-tag"
                        >
                          <span class="selected-plan-prefix">已选</span>
                          <span class="selected-plan-name">{{ selectedDefaultPlanName }}</span>
                        </el-tag>
                        <span v-else class="selected-plan-empty">未选择体检方案</span>
                        <el-button
                          v-if="isEditMode && currentPlan.defaultPlanId"
                          type="danger"
                          link
                          @click="clearDefaultPlan"
                        >
                          清空
                        </el-button>
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>

            <div v-else class="empty-state">
              <el-empty description="请先创建或选择一个体检方案定义" />
            </div>
          </div>
        </el-card>

        <el-card shadow="hover" class="plan-record-card">
          <template #header>
            <PageHeader size="card">
              <template #title>体检记录列表</template>
            </PageHeader>
          </template>

          <div class="record-list-container">
            <el-table
              v-if="inspectionRecordList.length"
              :data="inspectionRecordList"
              border
              stripe
              height="100%"
              size="small"
              class="record-table"
            >
              <el-table-column prop="评估类型" label="评估类型" min-width="120" show-overflow-tooltip>
                <template #default="{ row }">{{ row.评估类型 || '-' }}</template>
              </el-table-column>
              <el-table-column prop="体检人员" label="体检人员" min-width="120" show-overflow-tooltip>
                <template #default="{ row }">{{ row.体检人员 || '-' }}</template>
              </el-table-column>
              <el-table-column prop="提交时间" label="提交时间" min-width="170" show-overflow-tooltip>
                <template #default="{ row }">{{ formatDateText(row.提交时间) }}</template>
              </el-table-column>
              <el-table-column prop="数据唯一ID" label="数据唯一ID" min-width="150" show-overflow-tooltip>
                <template #default="{ row }">{{ row.数据唯一ID || '-' }}</template>
              </el-table-column>
              <el-table-column label="操作" width="100" fixed="right" align="center">
                <template #default="{ row }">
                  <el-button type="primary" size="small" link @click="openRecordDetail(row)">
                    详情
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-empty v-else description="暂无体检记录" />
          </div>
        </el-card>
      </div>
    </div>

    <el-dialog
      v-model="defaultPlanDialogVisible"
      title="选择默认体检方案"
      width="820px"
      top="6vh"
      append-to-body
      :close-on-click-modal="false"
    >
      <el-radio-group v-model="selectedDefaultPlanId" class="default-plan-radio-group">
        <el-table
          :data="defaultPlanList"
          v-loading="defaultPlanListLoading"
          border
          stripe
          highlight-current-row
          height="430"
          :row-key="getRowId"
          @row-click="selectDefaultPlanRow"
        >
          <el-table-column label="选择" width="70" align="center">
            <template #default="{ row }">
              <el-radio
                :label="String(getRowId(row))"
                @change="selectDefaultPlanRow(row)"
              >
                &nbsp;
              </el-radio>
            </template>
          </el-table-column>
          <el-table-column prop="名称" label="体检方案名称" min-width="220">
            <template #default="{ row }">
              {{ getDefaultPlanName(row) }}
            </template>
          </el-table-column>
          <el-table-column prop="最后修改人" label="最后修改人" width="130">
            <template #default="{ row }">
              {{ row.最后修改人 || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="版本" label="版本" width="110">
            <template #default="{ row }">
              {{ row.版本 || '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="实施日期" label="实施日期" width="180">
            <template #default="{ row }">
              {{ formatDateText(row.实施日期) }}
            </template>
          </el-table-column>
        </el-table>
      </el-radio-group>

      <div class="dialog-pagination">
        <el-pagination
          v-model:current-page="defaultPlanPagination.page"
          v-model:page-size="defaultPlanPagination.pageSize"
          :page-sizes="defaultPlanPagination.pageSizes"
          :total="defaultPlanPagination.total"
          layout="total, sizes, prev, pager, next, jumper"
          small
          @size-change="handleDefaultPlanPageSizeChange"
          @current-change="handleDefaultPlanPageChange"
        />
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="defaultPlanDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmDefaultPlanSelection">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script lang="ts" setup>
import { computed, nextTick, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { Close, DocumentChecked, Edit, Plus, Refresh, RefreshLeft } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import PageHeader from '@/components/PageHeader.vue';
import DynamicTable from '@/components/DynamicTable.vue';
import { ParameterSettings } from '@/network/index';
import { getMenuChildPathByComponent } from '@/utils/menuRoute';

const router = useRouter();

interface HouseCheckPlanData {
  id: string;
  projectName: string;
  projectCode: string;
  defaultPlanId: string;
  defaultPlanName: string;
  clientName: string;
  clientPhone: string;
  ownerName: string;
  ownerPhone: string;
  userName: string;
  managerName: string;
}

const planList = ref<any[]>([]);
const planTableModel = ref<Record<string, string> | undefined>(undefined);
const planHiddenColumns = ['状态', 'status', 'Status'];
const hiddenPlanListFields = new Set(planHiddenColumns.map(field => field.toLowerCase()));
const planTableLabels: Record<string, string> = {
  ID: 'ID',
  Id: 'ID',
  id: 'ID',
  项目名称: '项目名称',
  项目编码: '项目编码',
  委托人: '委托人',
  委托人联系电话: '委托人联系电话',
  所有权人: '所有权人',
  所有权人联系电话: '所有权人联系电话',
  使用人: '使用人',
  管理人: '管理人'
};
const planTableColumnOrder = ['项目名称', '项目编码', '委托人', '委托人联系电话', '所有权人', '所有权人联系电话', '使用人', '管理人'];

const listLoading = ref<boolean>(false);
const detailLoading = ref<boolean>(false);
const saveLoading = ref<boolean>(false);
const isEditMode = ref<boolean>(false);
const activePlanIndex = ref<number>(-1);
const filterParams = ref<any[]>([]);
const currentPlan = ref<HouseCheckPlanData | null>(null);
const inspectionRecordList = ref<any[]>([]);
const planFormRef = ref<any>(null);
const defaultPlanDialogVisible = ref<boolean>(false);
const defaultPlanListLoading = ref<boolean>(false);
const defaultPlanList = ref<any[]>([]);
const selectedDefaultPlanId = ref<string>('');
const selectedDefaultPlanRow = ref<any | null>(null);

const planPagination = ref({
  show: true,
  page: 1,
  pageSize: 10,
  total: 0,
  pageSizes: [10, 20, 50, 100],
  layout: 'total, prev, pager, next',
  small: true
});

const defaultPlanPagination = ref({
  page: 1,
  pageSize: 10,
  total: 0,
  pageSizes: [10, 20, 50, 100]
});

const validateDefaultPlanId = (_rule: any, value: string, callback: (error?: Error) => void) => {
  if (!value || value === '0') {
    callback(new Error('请选择默认体检方案'));
    return;
  }
  callback();
};

const planFormRules = {
  projectName: [{ required: true, message: '请输入项目名称', trigger: 'blur' }],
  projectCode: [{ required: true, message: '请输入项目编码', trigger: 'blur' }],
  clientName: [{ required: true, message: '请输入委托人', trigger: 'blur' }],
  clientPhone: [{ required: true, message: '请输入委托人联系电话', trigger: 'blur' }],
  ownerName: [{ required: true, message: '请输入所有权人', trigger: 'blur' }],
  ownerPhone: [{ required: true, message: '请输入所有权人联系电话', trigger: 'blur' }],
  userName: [{ required: true, message: '请输入使用人', trigger: 'blur' }],
  managerName: [{ required: true, message: '请输入管理人', trigger: 'blur' }],
  defaultPlanId: [{ validator: validateDefaultPlanId, trigger: 'change' }]
};

const activePlanRowKey = computed(() => {
  if (activePlanIndex.value < 0 || activePlanIndex.value >= planList.value.length) return null;
  const item = planList.value[activePlanIndex.value];
  return item?.ID ?? item?.Id ?? item?.id ?? null;
});

const getRowId = (row: any) => row?.ID ?? row?.Id ?? row?.id ?? '';

const getDefaultPlanName = (row: any) => row?.名称 ?? row?.name ?? row?.报告模板名称 ?? '未命名体检方案';

const normalizeId = (value: any): string => {
  const text = String(value ?? '');
  return text === '0' ? '' : text;
};

const formatDateText = (value: any): string => {
  if (!value) return '-';
  return String(value).replace('T', ' ');
};

const createEmptyPlan = (): HouseCheckPlanData => ({
  id: '',
  projectName: '',
  projectCode: '',
  defaultPlanId: '',
  defaultPlanName: '',
  clientName: '',
  clientPhone: '',
  ownerName: '',
  ownerPhone: '',
  userName: '',
  managerName: ''
});

const isHiddenPlanField = (fieldName: any) => hiddenPlanListFields.has(String(fieldName ?? '').toLowerCase());

const transformBackendToPlanData = (data: any): HouseCheckPlanData => ({
  id: String(data?.ID ?? data?.Id ?? data?.id ?? ''),
  projectName: data?.项目名称 ?? data?.projectName ?? '',
  projectCode: data?.项目编码 ?? data?.projectCode ?? '',
  defaultPlanId: normalizeId(data?.默认体检方案id ?? data?.默认体检方案Id ?? data?.defaultPlanId),
  defaultPlanName: '',
  clientName: data?.委托人 ?? data?.clientName ?? '',
  clientPhone: data?.委托人联系电话 ?? data?.clientPhone ?? '',
  ownerName: data?.所有权人 ?? data?.ownerName ?? '',
  ownerPhone: data?.所有权人联系电话 ?? data?.ownerPhone ?? '',
  userName: data?.使用人 ?? data?.userName ?? '',
  managerName: data?.管理人 ?? data?.managerName ?? ''
});

const transformPlanDataToBackend = (data: HouseCheckPlanData) => ({
  项目名称: data.projectName || '',
  项目编码: data.projectCode || '',
  委托人: data.clientName,
  委托人联系电话: data.clientPhone,
  所有权人: data.ownerName,
  所有权人联系电话: data.ownerPhone,
  使用人: data.userName,
  管理人: data.managerName,
  默认体检方案id: data.defaultPlanId || '0',
  Id: data.id || '0'
});

const findPlanIndex = (row: any): number => {
  const rowId = String(getRowId(row));
  return planList.value.findIndex((item: any) => {
    const itemId = String(getRowId(item));
    return rowId && itemId ? itemId === rowId : item === row;
  });
};

const findPlanItem = (targetId?: number | string): any => {
  if (targetId === undefined || targetId === null || targetId === '') return null;
  const targetText = String(targetId);
  return planList.value.find((item: any) => String(getRowId(item)) === targetText);
};

const selectedDefaultPlanName = computed(() => {
  if (!currentPlan.value?.defaultPlanId) return '未选择';
  return currentPlan.value.defaultPlanName || '已选择默认体检方案';
});

const resolveDefaultPlanNameById = async (id: string) => {
  if (!id || !currentPlan.value) return;
  try {
    const res = await ParameterSettings.houseCheckById({ id });
    if (res && res.status === 200 && res.success && res.response && currentPlan.value?.defaultPlanId === id) {
      currentPlan.value.defaultPlanName = res.response.名称 || res.response.name || currentPlan.value.defaultPlanName;
    }
  } catch (error) {
    console.error('加载默认体检方案名称失败:', error);
  }
};

const loadDefaultPlanList = async () => {
  try {
    defaultPlanListLoading.value = true;
    const paginationData = {
      page: defaultPlanPagination.value.page,
      intPageSize: defaultPlanPagination.value.pageSize
    };
    const res = await ParameterSettings.houseCheckListIndex(paginationData, []);
    if (res && res.status === 200 && res.success && res.response) {
      const responseData = Array.isArray(res.response) ? res.response : (res.response.data || []);
      defaultPlanList.value = Array.isArray(responseData) ? responseData : [];
      defaultPlanPagination.value.total = res.response.dataCount || res.response.total || res.response.count || 0;

      const currentSelected = defaultPlanList.value.find((item: any) => String(getRowId(item)) === selectedDefaultPlanId.value);
      if (currentSelected) {
        selectedDefaultPlanRow.value = currentSelected;
      }
    } else {
      defaultPlanList.value = [];
      defaultPlanPagination.value.total = 0;
    }
  } catch (error) {
    console.error('加载默认体检方案列表失败:', error);
    defaultPlanList.value = [];
    defaultPlanPagination.value.total = 0;
    ElMessage.error('加载默认体检方案列表失败');
  } finally {
    defaultPlanListLoading.value = false;
  }
};

const openDefaultPlanDialog = async () => {
  if (!isEditMode.value) return;
  selectedDefaultPlanId.value = currentPlan.value?.defaultPlanId || '';
  selectedDefaultPlanRow.value = null;
  defaultPlanPagination.value.page = 1;
  defaultPlanDialogVisible.value = true;
  await loadDefaultPlanList();
};

const selectDefaultPlanRow = (row: any) => {
  const rowId = getRowId(row);
  if (!rowId) return;
  selectedDefaultPlanId.value = String(rowId);
  selectedDefaultPlanRow.value = row;
};

const confirmDefaultPlanSelection = async () => {
  if (!selectedDefaultPlanId.value) {
    ElMessage.warning('请选择默认体检方案');
    return;
  }
  if (!currentPlan.value) return;
  currentPlan.value.defaultPlanId = selectedDefaultPlanId.value;
  currentPlan.value.defaultPlanName = selectedDefaultPlanRow.value ? getDefaultPlanName(selectedDefaultPlanRow.value) : '';
  defaultPlanDialogVisible.value = false;
  await nextTick();
  planFormRef.value?.validateField?.('defaultPlanId');
};

const clearDefaultPlan = async () => {
  if (!currentPlan.value) return;
  currentPlan.value.defaultPlanId = '';
  currentPlan.value.defaultPlanName = '';
  await nextTick();
  planFormRef.value?.validateField?.('defaultPlanId');
};

const handleDefaultPlanPageChange = (page: number) => {
  defaultPlanPagination.value.page = page;
  loadDefaultPlanList();
};

const handleDefaultPlanPageSizeChange = (pageSize: number) => {
  defaultPlanPagination.value.pageSize = pageSize;
  defaultPlanPagination.value.page = 1;
  loadDefaultPlanList();
};

const loadPlanList = async () => {
  try {
    listLoading.value = true;
    const paginationData = {
      page: planPagination.value.page,
      intPageSize: planPagination.value.pageSize
    };
    const res = await ParameterSettings.houseCheckPlanListIndex(paginationData, filterParams.value);

    if (res && res.status === 200 && res.success && res.response) {
      const responseList = Array.isArray(res.response.data) ? res.response.data : [];
      planList.value = responseList;
      planPagination.value.total = res.response.dataCount || res.response.total || res.response.count || 0;
      planTableModel.value = res.response.model && typeof res.response.model === 'object'
        ? res.response.model
        : undefined;
    } else {
      planList.value = [];
      planTableModel.value = undefined;
      planPagination.value.total = 0;
    }
  } catch (error) {
    console.error('加载体检方案定义列表失败:', error);
    planList.value = [];
    ElMessage.error('加载体检方案定义列表失败');
  } finally {
    listLoading.value = false;
  }
};

const handleFilter = (filters: any[]) => {
  filterParams.value = filters.filter((item: any) => !isHiddenPlanField(item?.FieldName ?? item?.fieldName));
  planPagination.value.page = 1;
  loadPlanList();
};

const handlePlanPageChange = (page: number) => {
  planPagination.value.page = page;
  loadPlanList();
};

const handlePlanPageSizeChange = (pageSize: number) => {
  planPagination.value.pageSize = pageSize;
  planPagination.value.page = 1;
  loadPlanList();
};

const handlePlanSelect = async (row: any) => {
  const itemId = getRowId(row);
  if (!itemId) return;

  const index = findPlanIndex(row);
  activePlanIndex.value = index;

  try {
    detailLoading.value = true;
    const res = await ParameterSettings.houseCheckPlanById({ id: itemId });
    if (res && res.status === 200 && res.success && res.response) {
      currentPlan.value = transformBackendToPlanData(res.response);
      inspectionRecordList.value = Array.isArray(res.response.房屋建筑定期体检项目原始数据主表集合)
        ? res.response.房屋建筑定期体检项目原始数据主表集合
        : [];
      isEditMode.value = false;
      if (currentPlan.value.defaultPlanId) {
        resolveDefaultPlanNameById(currentPlan.value.defaultPlanId);
      }
      await nextTick();
      planFormRef.value?.clearValidate?.();
    } else {
      currentPlan.value = null;
      inspectionRecordList.value = [];
      isEditMode.value = false;
      ElMessage.error('数据加载失败');
    }
  } catch (error) {
    console.error('加载体检方案定义详情失败:', error);
    currentPlan.value = null;
    inspectionRecordList.value = [];
    isEditMode.value = false;
    ElMessage.error('数据加载失败');
  } finally {
    detailLoading.value = false;
  }
};

const handlePlanEdit = (row: any) => {
  handlePlanSelect(row);
};

const openRecordDetail = (row: any) => {
  const recordId = row?.Id ?? row?.ID ?? row?.id;
  if (!recordId) {
    ElMessage.warning('未获取到体检记录ID');
    return;
  }
  router.push({
    path: getMenuChildPathByComponent(
      '/HomeInspection/HouseCheckPlanDefinition/index.vue',
      '体检记录详情',
      '/房屋建筑定期体检/体检项目定义/体检记录详情'
    ),
    query: { id: String(recordId) }
  });
};

const addNewPlan = async () => {
  currentPlan.value = createEmptyPlan();
  inspectionRecordList.value = [];
  activePlanIndex.value = -1;
  isEditMode.value = true;
  await nextTick();
  planFormRef.value?.clearValidate?.();
};

const enterEditMode = () => {
  if (!currentPlan.value) return;
  (currentPlan.value as any)._backup = JSON.parse(JSON.stringify(currentPlan.value));
  isEditMode.value = true;
};

const exitEditMode = () => {
  if (!currentPlan.value) return;
  const backup = (currentPlan.value as any)._backup;
  if (backup) {
    currentPlan.value = backup;
    delete (currentPlan.value as any)._backup;
  } else if (!currentPlan.value.id) {
    currentPlan.value = null;
    inspectionRecordList.value = [];
  }
  isEditMode.value = false;
};

const resetCurrentPlan = async () => {
  if (!currentPlan.value) return;
  if (currentPlan.value.id) {
    const currentItem = findPlanItem(currentPlan.value.id);
    if (currentItem) {
      await handlePlanSelect(currentItem);
      isEditMode.value = true;
    }
  } else {
    currentPlan.value = createEmptyPlan();
    inspectionRecordList.value = [];
    await nextTick();
    planFormRef.value?.clearValidate?.();
  }
};

const savePlanData = async () => {
  if (!currentPlan.value || !planFormRef.value) return;

  await planFormRef.value.validate(async (valid: boolean) => {
    if (!valid || !currentPlan.value) {
      ElMessage.warning('请填写必填项后再保存');
      return;
    }

    const isNew = !currentPlan.value.id;
    const submitData = transformPlanDataToBackend(currentPlan.value);

    try {
      saveLoading.value = true;
      const res = await ParameterSettings.houseCheckPlanSave(submitData);
      if (res && res.status === 200 && res.success) {
        ElMessage.success(isNew ? '新增成功' : '更新成功');
        isEditMode.value = false;
        const savedId = res.response?.ID ?? res.response?.Id ?? res.response?.id ?? submitData.Id;
        if (isNew) {
          planPagination.value.page = 1;
        }
        await loadPlanList();
        const foundItem = findPlanItem(savedId);
        if (foundItem) {
          await handlePlanSelect(foundItem);
        } else {
          currentPlan.value = null;
          inspectionRecordList.value = [];
          activePlanIndex.value = -1;
        }
      } else {
        ElMessage.error(isNew ? '新增失败' : '更新失败');
      }
    } catch (error) {
      console.error('保存体检方案定义失败:', error);
      ElMessage.error(isNew ? '新增失败' : '更新失败');
    } finally {
      saveLoading.value = false;
    }
  });
};

const handlePlanDelete = (row: any) => {
  const index = findPlanIndex(row);
  const itemId = getRowId(row);
  if (index < 0 || !itemId) return;

  ElMessageBox.confirm('确定要删除这个体检方案定义吗？删除后无法恢复', '提示', {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(async () => {
    try {
      const res = await ParameterSettings.houseCheckPlanDelete({ id: itemId });
      if (res && res.status === 200 && res.success) {
        const activeId = currentPlan.value?.id;
        if (activeId && String(activeId) === String(itemId)) {
          currentPlan.value = null;
          inspectionRecordList.value = [];
          activePlanIndex.value = -1;
          isEditMode.value = false;
        }
        if (planList.value.length === 1 && planPagination.value.page > 1) {
          planPagination.value.page--;
        }
        await loadPlanList();
        ElMessage.success('删除成功');
      } else {
        ElMessage.error('删除失败');
      }
    } catch (error) {
      console.error('删除体检方案定义失败:', error);
      ElMessage.error('删除失败');
    }
  }).catch(() => { /* cancelled */ });
};

onMounted(() => {
  loadPlanList();
});
</script>

<style lang="less" scoped>
.plan-definition-container {
  height: 100%;
  min-height: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .main-content {
    display: flex;
    gap: 20px;
    flex: 1;
    height: 0;
    min-height: 0;
    overflow: hidden;
  }

  .left-panel {
    flex: 0 0 40%;
    max-width: 40%;
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
  }

  .list-card {
    height: 100%;
    display: flex;
    flex-direction: column;

    :deep(.el-card__body) {
      flex: 1;
      padding: 0;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      min-height: 0;
    }

    .plan-list-wrapper {
      flex: 1;
      overflow: hidden;
      padding: 0.5rem;
      display: flex;
      flex-direction: column;

      :deep(.dynamic-table-card) {
        box-shadow: none;
        border: none;
        height: 100%;
        display: flex;
        flex-direction: column;

        .el-card__body {
          flex: 1;
          height: 0;
          overflow: hidden;
          display: flex;
          flex-direction: column;
        }
      }

      :deep(.el-table) {
        height: 100%;

        .el-table__row {
          cursor: pointer;
        }
      }
    }
  }

  .right-panel {
    flex: 1;
    min-width: 0;
    min-height: 0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 16px;

    .plan-form-card {
      flex: 0 0 56%;
      min-height: 430px;
      display: flex;
      flex-direction: column;

      :deep(.el-card__body) {
        flex: 1;
        padding: 0;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        min-height: 0;
      }
    }

    .plan-record-card {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;

      :deep(.el-card__body) {
        flex: 1;
        padding: 0;
        overflow: hidden;
        display: flex;
        flex-direction: column;
        min-height: 0;
      }
    }

    .plan-detail-container {
      flex: 1;
      min-height: 0;
      display: flex;
      flex-direction: column;
    }

    .edit-area {
      flex: 1;
      min-height: 0;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    .edit-mode-control {
      padding: 16px 20px;
      border-bottom: 1px solid #e4e7ed;
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-shrink: 0;

      .left-actions,
      .right-actions {
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }

    .form-content {
      flex: 1;
      min-height: 0;
      overflow-y: auto;
      overflow-x: hidden;
      padding: 20px 24px 16px;
      width: 100%;
      max-width: 1120px;

      :deep(.el-row) {
        margin-left: 0 !important;
        margin-right: 0 !important;
      }

      :deep(.el-form-item) {
        margin-bottom: 14px;
      }

      :deep(.el-form-item__label) {
        font-weight: 600;
        color: #475569;
      }

      :deep(.el-input) {
        width: 100%;
        max-width: 360px;
      }

      :deep(.el-input__wrapper) {
        min-height: 34px;
      }

      .default-plan-control {
        display: flex;
        align-items: center;
        gap: 12px;
        min-width: 0;
        max-width: 760px;
        flex-wrap: wrap;

        .choose-plan-btn {
          flex-shrink: 0;
        }

        .selected-plan-tag {
          max-width: 420px;
          height: 34px;
          padding: 0 12px;
          border-radius: 4px;
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-size: 14px;
          font-weight: 600;
          border-color: #b7ebc6;
          background-color: #f0fdf4;
          color: #166534;

          .selected-plan-prefix {
            flex-shrink: 0;
            color: #16a34a;
          }

          .selected-plan-name {
            min-width: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .selected-plan-empty {
          min-width: 0;
          color: #94a3b8;
          font-size: 14px;
        }

        :deep(.el-button--danger.is-link) {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }

    @media (max-width: 1200px) {
      .form-content {
        :deep(.el-input) {
          max-width: 100%;
        }

        .default-plan-control {
          .selected-plan-tag {
            max-width: 100%;
          }
        }
      }
    }

    @media (max-width: 768px) {
      .form-content {
        padding: 16px;

        .default-plan-control {
          align-items: flex-start;
          flex-direction: column;

          .choose-plan-btn,
          .selected-plan-tag {
            width: 100%;
          }

          .selected-plan-tag {
            justify-content: flex-start;

            .selected-plan-name {
              flex: 1;
            }
          }
        }
      }
    }

    .empty-state {
      flex: 1;
      min-height: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }

    .record-list-container {
      flex: 1;
      min-height: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;

      .record-table {
        width: 100%;
        height: 100%;
      }
    }
  }

  .dialog-pagination {
    display: flex;
    justify-content: flex-end;
    padding-top: 12px;
  }

  .default-plan-radio-group {
    width: 100%;
    display: block;
  }

  :deep(.el-radio__label) {
    padding-left: 0;
  }
}
</style>

